module.exports = __webpack_public_path__ + "static/marek-5d591844037cf6bd674226385484c817.jpg";